import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { useDispatch, useSelector } from "react-redux";
import { addNews, clearErrors } from "../../../actions/adminNewsActions";
import { ADD_NEWS_RESET } from "./../../../constants/adminNewsConstants";

import Loader from "../../Loader";
import FroalaEditor from "react-froala-wysiwyg";
import withFroalaLicense from "../../../utils/froalaConfig";

import "./News.css";

const AddNews = ({ history, match }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const [news, setNews] = useState({
    title: "",
    description: "",
    logo: "",
    status: false,
    imageName: "",
  });
  const [errorData, setErrorData] = useState({});

  const { title, description, status, logo, imageName } = news;

  const { isNewsAdded, user_loading, error, errors } = useSelector(
    (state) => state.newsDetail
  );

  useEffect(() => {
    if (errors) {
      setErrorData(errors);
    }

    if (error) {
      clearErrors();
      return alert.error(error);
    }

    if (isNewsAdded === true && isNewsAdded != undefined) {
      alert.success("News successfully added.");
      history.push("/admin/news-list");
      dispatch({
        type: ADD_NEWS_RESET,
      });
    }
  }, [dispatch, isNewsAdded, alert, error, errors]);

  const onChange = (e) => {
    if (e.target.name === "logo") {
      let file = e.target.files[0];

      if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        setNews({
          ...news,
          logo: "",
          imageName: "",
        });
        alert.error("Please select valid logo.");
        //remove preview picture if any
        const preview = document.getElementById("img-preview");
        preview.src = "";
        return false;
      }

      const reader = new FileReader();

      reader.onload = function (readerEvt) {
        // The file's text will be printed here
        //console.log(readerEvt.target.result);
        let binaryString = readerEvt.target.result;
        let base64String = btoa(binaryString);
        setNews({
          ...news,
          logo: base64String,
          imageName: file.name,
        });

        //preview picture
        const preview = document.getElementById("img-preview");
        // console.log('banary image', base64String);
        preview.src = "data:image/png;base64," + base64String;
      };
      reader.readAsBinaryString(file);
    } else if (e.target.name === "status") {
      setNews({
        ...news,
        status: !status,
      });
    } else {
      setNews({
        ...news,
        [e.target.name]: e.target.value,
      });
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(addNews(title, description, status, logo, imageName));
  };

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Add
                <small>News</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link to="/admin/news-list">
                    <i className="fa fa-table"></i> News
                  </Link>
                </li>
                <li className="active">Add News</li>
              </ol>
            </section>

            <section className="content">
              <div className="box box-default">
                <div className="box-header with-border">
                  <h3 className="box-title">Add News</h3>

                  {/*<div className="box-tools pull-right">

                                    </div>*/}
                </div>

                <form
                  id="quickForm"
                  onSubmit={submitHandler}
                  encType="multipart/form-data"
                >
                  <div className="box-body">
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="title">Title</label>
                        <input
                          type="text"
                          name="title"
                          className="form-control"
                          id="title"
                          placeholder="Enter the news title"
                          value={title}
                          onChange={onChange}
                        />
                        {errorData.title ? (
                          <span className="text-danger">{errorData.title}</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="description">Description</label>
                        <FroalaEditor
                          tag="textarea"
                          model={description ?? ''}
                          onModelChange={(content) => setNews({ ...news, description: content })}
                          config={withFroalaLicense({
                            height: 300,
                            toolbarButtons: [
                              'bold', 'italic', 'underline', 'strikeThrough', '|',
                              'fontFamily', 'fontSize', 'textColor', 'backgroundColor', '|',
                              'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', '|',
                              'formatOL', 'formatUL', 'paragraphFormat', '|',
                              'insertLink', 'insertImage', 'insertVideo', 'insertTable', '|',
                              'undo', 'redo', 'fullscreen', 'html'
                            ],
                            quickInsertTags: [''],
                            pasteAllowLocalImages: true,
                            imageUpload: true,
                            imageUploadParams: { folder: 'news' }
                          })}
                        />
                        {errorData.description ? (
                          <span className="text-danger">
                            {errorData.description}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="logo">Image</label>
                        <input
                          type="file"
                          className="form-control"
                          id="logo"
                          name="logo"
                          onChange={onChange}
                          accept={`.jpeg, .jpg, .png`}
                        />
                        {errorData.logo ? (
                          <span className="text-danger">{errorData.logo}</span>
                        ) : (
                          ""
                        )}
                        <div>
                          <img id="img-preview" src="" />
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="status">Status</label>
                        <input
                          style={{ marginRight: "5px" }}
                          type="checkbox"
                          className="form-check-input"
                          id="status"
                          name="status"
                          checked={status}
                          value={status}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default AddNews;
